// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b0b5e5c0","866":"ac2c907e"}[chunkId] + ".chunk.js";
};